import React, { createContext, useState, useEffect, useContext } from 'react';

const APP_PREFIX = 'DECARBONIZATION_DASHBOARD_METABUILD'; // Change this per project

// Simple Base64 encode/decode helpers
const encode = (str) => {
    return window.btoa(String.fromCharCode(...new TextEncoder().encode(str)));
};

const decode = (str) => {
    try {
        const bytes = Uint8Array.from(window.atob(str), c => c.charCodeAt(0));
        return new TextDecoder().decode(bytes);
    } catch {
        return '';
    }
};

const UserContext = createContext();

export const UserContextProvider = ({ children }) => {
    const [token, setToken] = useState(() => {
        const stored = localStorage.getItem(`${APP_PREFIX}token`);
        return stored ? decode(stored) : null;
    });
    const [username, setUsername] = useState(() => {
        const stored = localStorage.getItem(`${APP_PREFIX}username`);
        return stored ? decode(stored) : null;
    });

    useEffect(() => {
        if (token) {
            localStorage.setItem(`${APP_PREFIX}token`, encode(token));
        } else {
            localStorage.removeItem(`${APP_PREFIX}token`);
        }
    }, [token]);

    useEffect(() => {
        if (username) {
            localStorage.setItem(`${APP_PREFIX}username`, encode(username));
        } else {
            localStorage.removeItem(`${APP_PREFIX}username`);
        }
    }, [username]);

    const login = (token, username) => {
        setToken(token);
        setUsername(username);
    };

    const logout = () => {
        setToken(null);
        setUsername(null);
        localStorage.removeItem(`${APP_PREFIX}token`);
        localStorage.removeItem(`${APP_PREFIX}username`);
    };

    return (
        <UserContext.Provider value={{ token, username, login, logout }}>
            {children}
        </UserContext.Provider>
    );
};

export const useUserContext = () => useContext(UserContext);
